/* INTEGY V577 — collection-aware stock owner; native Shopify where reliable, indexed/live-verified Traxxas stock, filtered pagination, view state, and Back-safe ownership. */
(function () {
  'use strict';
  if (window.IntegyV576CommerceOwner || window.IntegyV449CommerceOwner) return;

  var root = document.documentElement;
  var refreshTimer = 0;
  var observerTimer = 0;
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 860px), (pointer: coarse) and (max-width: 1368px)') : null;

  function qs(selector, scope) {
    try { return (scope || document).querySelector(selector); } catch (error) { return null; }
  }
  function qsa(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); } catch (error) { return []; }
  }
  function isMobile() { return !!(mobileQuery && mobileQuery.matches); }
  function isCollection() { return !!(document.body && document.body.classList.contains('template-collection')); }
  function supportsViews() {
    return !!(document.body && (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')));
  }
  function outer() { return qs('.productgrid--outer'); }
  function validMode(value) { return value === 'list-view' || value === 'grid-view' ? value : ''; }
  function requestedMode() {
    var mode = '';
    try { mode = validMode(new URL(location.href).searchParams.get('grid_list')); } catch (error) {}
    if (!mode) {
      try { mode = validMode(localStorage.getItem('integy_collection_view')); } catch (error) {}
    }
    return mode || 'grid-view';
  }
  function updateViewButtons(mode) {
    qsa('[data-collection-view]').forEach(function (button) {
      var active = button.getAttribute('data-collection-view') === mode;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  function applyViewMode(mode, updateUrl) {
    mode = validMode(mode) || requestedMode();
    var shell = outer();
    if (!shell) return false;
    var list = mode === 'list-view';
    shell.classList.toggle('productgrid-listview', list);
    shell.classList.toggle('productgrid-gridview', !list);
    shell.setAttribute('data-integy-v449-view', mode);
    updateViewButtons(mode);
    try { localStorage.setItem('integy_collection_view', mode); } catch (error) {}
    if (updateUrl && history && history.replaceState) {
      try {
        var url = new URL(location.href);
        url.searchParams.set('grid_list', mode);
        history.replaceState(history.state, '', url.pathname + '?' + url.searchParams.toString() + url.hash);
      } catch (error) {}
    }
    return true;
  }

  function nativeAvailability() {
    return useNativeStockOwner();
  }
  function canonicalFilterOwnerOwnsStock() {
    try {
      return !!(window.IntegyV501FilterOwner &&
        typeof window.IntegyV501FilterOwner.ownsStockForCurrentCollection === 'function' &&
        window.IntegyV501FilterOwner.ownsStockForCurrentCollection());
    } catch (error) {
      return false;
    }
  }
  function canonicalIndexedStockAvailable() {
    try {
      if (!window.IntegyV501FilterOwner || typeof window.IntegyV501FilterOwner.indexedStockOwnerForCollection !== 'function') return false;
      var parts = String(location.pathname || '').split('/').filter(Boolean);
      var at = parts.indexOf('collections');
      var handle = at >= 0 && parts[at + 1] ? decodeURIComponent(parts[at + 1]) : '';
      return !!handle && window.IntegyV501FilterOwner.indexedStockOwnerForCollection(handle);
    } catch (error) {
      return false;
    }
  }
  function useNativeStockOwner() {
    // V651: Shopify hides storefront filters above 5,000 products. If Liquid marked
    // this route as an oversized non-indexed collection, use the custom stock URL/owner.
    try {
      var v651 = window.INTEGY_V651_LARGE_STOCK_CONFIG || {};
      if (v651.active && !v651.indexed && Number(v651.count || 0) > 5000) return false;
    } catch (error) {}
    // V577: keep audited indexed-stock ownership stable even during initial script-order races.
    try {
      var parts = String(location.pathname || '').split('/').filter(Boolean);
      var at = parts.indexOf('collections');
      var handle = at >= 0 && parts[at + 1] ? decodeURIComponent(parts[at + 1]).toLowerCase() : '';
      if (/^(?:all|all-integy-hop-up-parts|hopups-for-traxxas|hop-up-parts-for-traxxas|parts-for-traxxas)$/.test(handle)) return false;
    } catch (error) {}
    return isCollection() && !canonicalIndexedStockAvailable();
  }

  function currentStockState() {
    var available = '';
    var stock = '';
    try {
      var url = new URL(location.href);
      available = url.searchParams.get('filter.v.availability') || '';
      stock = url.searchParams.get('integy_stock') || '';
    } catch (error) {}
    if (available === '0' || stock === 'out') return { inStock: false, outStock: true, mode: 'out' };
    if (stock === 'all') return { inStock: true, outStock: true, mode: 'all' };
    return { inStock: true, outStock: false, mode: 'in' };
  }
  function updateStockRootState(state) {
    root.classList.toggle('integy-v449-stock-in', state.mode === 'in');
    root.classList.toggle('integy-v449-stock-out', state.mode === 'out');
    root.classList.toggle('integy-v449-stock-all', state.mode === 'all');
  }
  function applyStockStateToUrl(url, state, native, resetPage) {
    if (!url || !state) return url;
    if (resetPage !== false) url.searchParams.delete('page');
    if (native) {
      url.searchParams.delete('integy_stock');
      if (state.inStock && !state.outStock) url.searchParams.set('filter.v.availability', '1');
      else if (!state.inStock && state.outStock) url.searchParams.set('filter.v.availability', '0');
      else {
        url.searchParams.delete('filter.v.availability');
        url.searchParams.set('integy_stock', 'all');
      }
    } else {
      url.searchParams.delete('filter.v.availability');
      if (state.inStock && !state.outStock) url.searchParams.set('integy_stock', 'in');
      else if (!state.inStock && state.outStock) url.searchParams.set('integy_stock', 'out');
      else url.searchParams.set('integy_stock', 'all');
    }
    return url;
  }
  function cardAvailable(card) {
    if (!card) return false;
    var explicit = card.getAttribute('data-product-available');
    if (explicit === 'true') return true;
    if (explicit === 'false') return false;
    var text = (card.textContent || '').toLowerCase();
    if (text.indexOf('out of stock') >= 0 || text.indexOf('sold out') >= 0) return false;
    return text.indexOf('in stock') >= 0 || text.indexOf('only ') >= 0;
  }
  function updateStockToggle(state) {
    qsa('[data-integy-v449-stock-toggle]').forEach(function (toggle) {
      qsa('[data-integy-v449-stock-mode]', toggle).forEach(function (button) {
        var mode = button.getAttribute('data-integy-v449-stock-mode');
        var pressed = mode === state.mode;
        button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });
    });
  }
  function filterOwnsCardVisibility(card) {
    if (!card) return false;
    return card.hasAttribute('data-integy-v307-hidden-mismatch') ||
      card.classList.contains('integy-v307-hidden-zero') ||
      card.hidden === true ||
      card.getAttribute('aria-hidden') === 'true' && !card.classList.contains('integy-v449-stock-hidden');
  }
  function authoritativeFilteredCount() {
    var filtered = root.classList.contains('integy-v458-filtered-route') || canonicalFilterOwnerOwnsStock();
    try { filtered = filtered || /(?:^|[?&])(?:integy_filter|integy_filters|integy_tag_filter|integy_vehicle_filter)=/i.test(location.search || ''); } catch (error) {}
    if (!filtered) return null;
    var candidates = qsa('.collection--product-count[data-integy-v307-count],.productgrid--count[data-integy-v307-count],.integy-collection-meta .integy-chip[data-integy-v307-count]');
    for (var i = 0; i < candidates.length; i += 1) {
      var value = Number(candidates[i].getAttribute('data-integy-v307-count'));
      if (Number.isFinite(value) && value >= 0) return value;
    }
    return null;
  }
  function applyClientInventory(state) {
    if (!isCollection()) return;
    updateStockRootState(state);
    // INTEGY V645: the large-sale sold-out owner renders a complete cross-page
    // live subset. The legacy page-local inventory hider must not touch it.
    if (window.IntegyV645SaleStockOwnerActive) {
      qsa('.productgrid--items .productgrid--item').forEach(function (card) {
        card.classList.remove('integy-v449-stock-hidden');
        card.removeAttribute('aria-hidden');
      });
      return;
    }
    var native = nativeAvailability();
    var explicitNative = false;
    try { explicitNative = new URL(location.href).searchParams.has('filter.v.availability'); } catch (error) {}

    // V536: when the canonical V501 owner renders a complete indexed stock/filter
    // result set, never apply the older page-local inventory hider on top of it.
    if (canonicalFilterOwnerOwnsStock()) {
      qsa('.productgrid--items .productgrid--item').forEach(function (card) {
        card.classList.remove('integy-v449-stock-hidden');
      });
      var authoritativeOwned = authoritativeFilteredCount();
      qsa('[data-integy-v449-stock-status]').forEach(function (status) {
        if (authoritativeOwned !== null) status.textContent = authoritativeOwned + ' matching item' + (authoritativeOwned === 1 ? '' : 's');
        else if (!status.textContent) status.textContent = 'Loading matching items…';
      });
      return;
    }

    var cards = qsa('.productgrid--items .productgrid--item');
    var visible = 0;
    cards.forEach(function (card) {
      var hiddenByFilter = filterOwnsCardVisibility(card);
      var available = cardAvailable(card);
      var stockMatch = (available && state.inStock) || (!available && state.outStock);
      var show = !hiddenByFilter && stockMatch;
      card.classList.toggle('integy-v449-stock-hidden', !stockMatch);
      if (hiddenByFilter) card.setAttribute('aria-hidden', 'true');
      else card.setAttribute('aria-hidden', stockMatch ? 'false' : 'true');
      if (show) visible += 1;
    });
    var authoritative = authoritativeFilteredCount();
    qsa('[data-integy-v449-stock-status]').forEach(function (status) {
      if (native && explicitNative) status.textContent = '';
      else if (authoritative !== null) status.textContent = authoritative + ' matching item' + (authoritative === 1 ? '' : 's');
      else if (cards.length) status.textContent = visible + ' matching item' + (visible === 1 ? '' : 's') + ' on this page';
      else status.textContent = '';
    });
  }

  function sameCollectionPath(url) {
    try {
      var current = location.pathname.split('/').filter(Boolean);
      var target = url.pathname.split('/').filter(Boolean);
      return current[0] === 'collections' && target[0] === 'collections' && current[1] && current[1] === target[1];
    } catch (error) { return false; }
  }
  function preserveStateInLink(anchor, mode, stockState) {
    if (!anchor || !anchor.href || /^javascript:/i.test(anchor.getAttribute('href') || '')) return;
    try {
      var url = new URL(anchor.href, location.origin);
      if (url.origin !== location.origin) return;
      var collectionLink = /\/collections\//.test(url.pathname);
      var pagingLink = !!(anchor.closest && anchor.closest('.pagination,.pagination--container,.integy-v426-filter-pagination,.integy-v458-vehicle-pagination'));
      var pagingOrFilter = collectionLink || url.searchParams.has('page') || url.searchParams.has('integy_filter') || url.searchParams.has('sort_by');
      if (supportsViews() && pagingOrFilter) url.searchParams.set('grid_list', mode);
      if (isCollection() && sameCollectionPath(url)) {
        if (pagingLink) {
          var current = new URL(location.href);
          ['integy_filter','integy_filters','integy_tag_filter','integy_vehicle_filter','sort_by'].forEach(function (name) {
            if (!url.searchParams.has(name) && current.searchParams.has(name)) url.searchParams.set(name, current.searchParams.get(name));
          });
        }
        applyStockStateToUrl(url, stockState, useNativeStockOwner(), !pagingLink);
      }
      anchor.href = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
    } catch (error) {}
  }
  function patchLinks(scope, mode, stockState) {
    if (!supportsViews() && !isCollection()) return;
    var selector = [
      '[data-productgrid-sidebar] a[href]',
      '.productgrid--sidebar a[href]',
      '.productgrid--active-filters a[href]',
      '.productgrid--utils-container a[href]',
      '.pagination a[href]',
      '.pagination--container a[href]',
      '.integy-v426-filter-pagination a[href]',
      '.integy-v458-vehicle-pagination a[href]'
    ].join(',');
    qsa(selector, scope || document).forEach(function (anchor) {
      if (anchor.matches('[data-collection-view]')) return;
      preserveStateInLink(anchor, mode, stockState);
    });
  }
  function patchForms(scope, state) {
    if (!isCollection()) return;
    qsa('form', scope || document).forEach(function (form) {
      if (!qs('select[name="sort_by"], [data-productgrid-trigger-sort]', form)) return;
      qsa('input[data-integy-v449-stock-input],input[data-integy-v458-state-input]', form).forEach(function (input) { input.remove(); });
      try {
        var currentUrl = new URL(location.href);
        ['integy_filter','integy_filters','integy_tag_filter','integy_vehicle_filter','grid_list'].forEach(function (fieldName) {
          if (!currentUrl.searchParams.has(fieldName)) return;
          var stateInput = document.createElement('input');
          stateInput.type = 'hidden';
          stateInput.name = fieldName;
          stateInput.value = currentUrl.searchParams.get(fieldName) || '';
          stateInput.setAttribute('data-integy-v458-state-input','true');
          form.appendChild(stateInput);
        });
      } catch (error) {}
      var native = useNativeStockOwner();
      var name = '';
      var value = '';
      if (native && state.inStock && !state.outStock) { name = 'filter.v.availability'; value = '1'; }
      else if (native && !state.inStock && state.outStock) { name = 'filter.v.availability'; value = '0'; }
      else if (!native || (state.inStock && state.outStock)) { name = 'integy_stock'; value = state.mode; }
      if (!name) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.setAttribute('data-integy-v449-stock-input', 'true');
      form.appendChild(input);
    });
  }

  function measureHeader() {
    var header = qs('.site-header');
    var value = header ? Math.max(72, Math.round(header.getBoundingClientRect().height)) : 82;
    root.style.setProperty('--integy-v440-measured-header-h', value + 'px');
    root.style.setProperty('--integy-v436-search-top', Math.min(value + 6, 150) + 'px');
  }
  function setupDescription(scope) {
    if (!isMobile() || !isCollection()) return;
    var description = qs('.collection--description', scope || document);
    if (!description || description.dataset.integyV449Collapse === 'true') return;
    var text = (description.textContent || '').trim();
    if (text.length < 220) return;
    description.dataset.integyV449Collapse = 'true';
    description.classList.add('integy-v440-collapsible-description');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'integy-v440-description-toggle';
    button.textContent = 'Read collection details';
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', function () {
      var expanded = description.classList.toggle('is-expanded');
      button.textContent = expanded ? 'Hide collection details' : 'Read collection details';
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
    description.insertAdjacentElement('afterend', button);
  }
  function improveSearch(scope) {
    qsa('input[type="search"],input[name="q"]', scope || document).forEach(function (input) {
      input.setAttribute('enterkeyhint', 'search');
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('spellcheck', 'false');
    });
  }
  function improveProductForm(scope) {
    if (!isMobile() || !document.body || !document.body.classList.contains('template-product')) return;
    qsa('.product-form--atc-button,[name="add"],.shopify-payment-button__button', scope || document).forEach(function (button) {
      button.classList.add('integy-v441-touch-purchase-control');
    });
    qsa('.quantity-selector input,[name="quantity"]', scope || document).forEach(function (input) {
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('enterkeyhint', 'done');
    });
  }
  function labelFilterTrigger(scope) {
    var panels = qsa('body.template-collection [data-productgrid-sidebar],body.template-collection .productgrid--sidebar,body.template-search [data-productgrid-sidebar],body.template-search .productgrid--sidebar');
    var panel = panels.find(function (candidate) {
      return candidate && (candidate.textContent || '').trim().length > 10 && !candidate.closest('[hidden]');
    }) || panels[0];
    if (panel) panel.id = panel.id || 'integy-v449-filter-dialog';
    var panelId = panel ? panel.id : 'integy-v449-filter-dialog';
    qsa('[data-productgrid-trigger-filters],.utils-filter-button', scope || document).forEach(function (trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', panelId);
    });
  }
  function normalizeTouchActions(scope) {
    // V555: Quick Shop only. Direct Add to Cart / Choose Options must remain keyboard and AT reachable.
    if (!isMobile()) return;
    qsa('body.template-collection .productgrid--item,body.template-search .productgrid--item', scope || document).forEach(function (card) {
      qsa('[data-quickshop-full],.quickshop-button', card).forEach(function (button) {
        button.setAttribute('aria-hidden', 'true');
        button.tabIndex = -1;
      });
    });
  }
  function normalizeAtcBanner(scope) {
    qsa('.atc-banner--container', scope || document).forEach(function (banner) {
      banner.setAttribute('role', 'dialog');
      banner.setAttribute('aria-label', 'Item added to cart');
    });
  }

  function refresh(scope) {
    var mode = requestedMode();
    var stockState = currentStockState();
    if (supportsViews()) applyViewMode(mode, false);
    updateStockToggle(stockState);
    applyClientInventory(stockState);
    patchLinks(scope || document, mode, stockState);
    patchForms(scope || document, stockState);
    setupDescription(scope || document);
    improveSearch(scope || document);
    improveProductForm(scope || document);
    labelFilterTrigger(scope || document);
    normalizeTouchActions(scope || document);
    normalizeAtcBanner(scope || document);
    measureHeader();
    root.classList.add('integy-v449-ready', 'integy-v449-view-ready');
  }
  function schedule(scope) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () { refresh(scope || document); }, 55);
  }

  document.addEventListener('click', function (event) {
    var stockButton = event.target && event.target.closest ? event.target.closest('[data-integy-v449-stock-mode]') : null;
    if (stockButton && isCollection()) {
      event.preventDefault();
      var state = currentStockState();
      var requestedStockMode = stockButton.getAttribute('data-integy-v449-stock-mode');
      if (requestedStockMode === 'all') {
        state.inStock = true;
        state.outStock = true;
      } else if (requestedStockMode === 'in') {
        state.inStock = true;
        state.outStock = false;
      } else {
        state.inStock = false;
        state.outStock = true;
      }
      state.mode = state.inStock && state.outStock ? 'all' : (state.inStock ? 'in' : 'out');
      var previousMode = currentStockState().mode;
      updateStockRootState(state);
      updateStockToggle(state);
      // Clicking the already-selected stock mode should be a no-op, not a full reload.
      if (state.mode === previousMode) {
        applyClientInventory(state);
        return;
      }
      try {
        if (window.IntegyV545NavigationState && typeof window.IntegyV545NavigationState.snapshot === 'function') {
          window.IntegyV545NavigationState.snapshot();
        }
        var stockUrl = applyStockStateToUrl(new URL(location.href), state, useNativeStockOwner());
        location.assign(stockUrl.pathname + (stockUrl.searchParams.toString() ? '?' + stockUrl.searchParams.toString() : '') + stockUrl.hash);
      } catch (error) {
        applyClientInventory(state);
      }
      return;
    }

    var viewButton = event.target && event.target.closest ? event.target.closest('[data-collection-view]') : null;
    if (viewButton && supportsViews()) {
      var mode = validMode(viewButton.getAttribute('data-collection-view'));
      if (!mode) return;
      window.setTimeout(function () {
        applyViewMode(mode, true);
        patchLinks(document, mode, currentStockState());
      }, 0);
      return;
    }

    var anchor = event.target && event.target.closest ? event.target.closest('[data-productgrid-sidebar] a[href],.productgrid--sidebar a[href],.productgrid--active-filters a[href],.productgrid--utils-container a[href],.pagination a[href],.pagination--container a[href],.integy-v426-filter-pagination a[href]') : null;
    if (anchor) preserveStateInLink(anchor, requestedMode(), currentStockState());
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('select[name="sort_by"],select[data-productgrid-trigger-sort]')) return;
    patchForms(select.form || document, currentStockState());
  }, true);

  document.addEventListener('integy:v429:filter-rendered', function () { schedule(document); });
  document.addEventListener('shopify:section:load', function (event) { schedule(event.target || document); });
  window.addEventListener('pageshow', function () { schedule(document); }, { passive: true });
  window.addEventListener('popstate', function () { schedule(document); }, { passive: true });
  window.addEventListener('resize', function () { measureHeader(); }, { passive: true });
  window.addEventListener('orientationchange', function () { window.setTimeout(function () { schedule(document); }, 120); }, { passive: true });

  function boot() {
    refresh(document);
    if (!window.MutationObserver) return;
    var main = qs('main') || document.body;
    if (!main) return;
    new MutationObserver(function (mutations) {
      if (!mutations.some(function (mutation) { return mutation.addedNodes && mutation.addedNodes.length; })) return;
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(function () { refresh(main); }, 90);
    }).observe(main, { childList: true, subtree: true });
  }

  window.IntegyV576CommerceOwner = window.IntegyV449CommerceOwner = {
    version: 'V577',
    refresh: refresh,
    applyViewMode: applyViewMode,
    currentStockState: currentStockState,
    applyClientInventory: applyClientInventory,
    useNativeStockOwner: useNativeStockOwner
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
